export default {
      id: "ar_dechets-usage",
      viewBox: "0 0 90 90",
      url: "../dist/images/" + "sprite.svg#ar_dechets-usage",
      toString: function () {
        return this.url;
      }
    }